import type { ThemeAppearance } from '@atlaskit/lozenge';

import { PluginName } from './types';

export const PLUGIN_LOZENGE_APPEARANCE: Record<PluginName, ThemeAppearance> = {
	[PluginName.SEARCH]: 'success',
	[PluginName.PEOPLE]: 'inprogress',
	[PluginName.TEAMWORK]: 'new',
	[PluginName.PAGE_SEARCH_PLUGIN]: 'moved',
};

/**
 * Default lozenge appearance for unknown plugins.
 */
export const DEFAULT_PLUGIN_LOZENGE_APPEARANCE: ThemeAppearance = 'default';
